export enum LocalStorageKeys {
  BOOT = 'boot',
  DOMAIN = 'domain',
}

export enum APIRoutes_V1 {
  BOOT = 'boot',
  BASE_API = 'checkout/v1',
  ORDERS = 'checkout/v1/orders',
}

export enum APIRoutes {
  BOOT = 'boot',
  DOMAIN = 'domain',
  LOG = 'log',
  BASE_URL = 'checkout/v1',
  BASE_URL_V3 = 'checkout/v3',
  CANCEL = 'cancel',
  ORDERS = 'orders',
  GET_SUBSCRIPTION = 'checkout/subscriptions',
  GET_CHECKOUT_SUMMARY = '',
  GET_SUBSCRIPTIONS_CHECKOUT_SUMMARY = 'checkout/subscriptions',
  NUVEI_SESSION = 'payments/session',
  APPLY_PROMO_CODE = 'apply-promo-code',
  FINALIZE_PAYMENT = 'finalize-payment',
  FINALIZE_SUBSCRIPTION_PAYMENT = 'checkout/subscriptions/finalize-subscription',
  CLOSE_SUBSCRIPTION = 'checkout/subscriptions/close',
  CALCULATE_SUBSCRIPTION_ESTIMATED_TAX = 'checkout/subscriptions/calculate-estimated-tax',
  CANCEL_PROMO_CODE = 'cancel-promo-code',
  NUVEI_PAYMENT_STATUS = 'payment/status',
  REMOVE_SAVED_CARD = 'remove-saved-card',
  GET_ADDRESS_SUGGESTIONS = 'address-auto-complete',
  CALCULATE_ESTIMATED_TAX = 'calculate-estimated-tax',
}

export enum ECheckoutStatus {
  INIT = 'init',
  PENDING = 'pending',
  SUCCESS_SHOW_PENDING = 'success_show_pending',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum InternalMessageEventsName {
  APM_REDIRECT = 'ac_apm_redirect',
  APM_REDIRECT_CLOSE = 'ac_apm_redirect_close',
}

export enum UsaStates {
  CALIFORNIA = 'ca',
}

export enum RedirectStatus {
  FAIL = 'fail',
  SUCCESS = 'success',
  CANCEL = 'cancel',
}

export enum Platform {
  IOS = 'ios',
  ANDROID = 'android',
  WEB = 'web',
}

export enum BrowserType {
  TWA = 'twa',
  CCT = 'cct',
  SFSVC = 'sfsvc',
  WEBVIEW = 'webview',
  EXTERNAL = 'external',
}
